var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"px-4 py-4 text-sm font-normal text-left text-gray-500 lg:px-6 w-[25px]"})
}
var staticRenderFns = []

export { render, staticRenderFns }